export const useRouteLeaveWarning = (
    dirty: Ref<boolean>, message: Ref<string> = null, afterLeave?: () => void = null
) => {

    function handle() {
        if (dirty.value) {
            if (!window.confirm(message)) return false
        }
        afterLeave && afterLeave()
    }

    return handle;
};
